import React, { useState, useRef, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Button, Form, Input, Dropdown, Loader } from "semantic-ui-react";
import TextEditor from "../../../../components/Admin/NewTextEditor";
import * as yup from "yup";
import { toast } from "react-toastify";

import {
  Container,
  Content,
  Title,
  Field,
  Label,
  SemanticTable,
} from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";

const Redirecionamento = (props) => {
  const [loading, setLoading] = useState(true);
  const [newRed, setNewRed] = useState({
    url_saida: "",
    url_destion: "",
  });
  const [redirect, setRedirect] = useState([]);

  useEffect(() => {
    loadAuth();
    loadRedirecionamentos();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadRedirecionamentos = async () => {
    await api
      .get(`/redirecionamentoTreinamento`)
      .then(async (res) => {
        let logs = {
          local: "redirecionamento/treinamento",
          texto: `listou os treinamentos`,
        };
        await api.post("system_logs", { acao: JSON.stringify(logs) });

        setRedirect(res.data);
        setLoading(false);
      })
      .catch((err) => {
        swal(
          "Não foi possível carregar os redirecionamentos de paginas de treinamento",
          err,
          "error"
        );
        setLoading(false);
      });
  };

  const removeRedirect = useCallback(
    (id) => {
      swal(
        "Remoção de redirecionamento",
        "Você tem certeza que quer remover ?",
        ""
      ).then((res) => {
        if (res) {
          api
            .delete(`admin/redirecionamentoTreinamento/${id}`)
            .then(async (res) => {
              let logs = {
                local: "redirecionamento/treinamento",
                texto: `deletou o treinamento de id=${id}`,
              };
              await api.post("system_logs", { acao: JSON.stringify(logs) });
              const newRedirect = [...redirect].filter((red) => red.id !== id);
              setRedirect(newRedirect);
            });
        }
      });
    },
    [redirect]
  );

  const create = useCallback(async () => {
    const redirectValidation = await yup.object().shape({
      url_saida: yup
        .string("Necessário que informe a url saida")
        .required("Necessário que informe a url saida"),
      url_destion: yup
        .string("Necessário que informe a url destino")
        .required("Necessário que informe a url destino"),
    });

    try {
      await redirectValidation.validate(newRed, { abortEarly: true });
      api
        .post(`/admin/redirecionamentoTreinamento`, newRed)
        .then(async (res) => {
          const { redirecionamento } = res.data;

          setRedirect((redirect) => [...redirect, redirecionamento]);

          let logs = {
            local: "redirecionameto/treinamento",
            texto: ` criou um redirecionamento de id=${redirecionamento.id}`,
          };
          await api.post("system_logs", { acao: JSON.stringify(logs) });
          swal(" redirecionamento salvo com sucesso", "", "success");
        })
        .catch((err) => {
          swal("Não foi possível salvar o redirecionamento", err, "");
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  }, [newRed, redirect]);

  return (
    <>
      <Container>
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Redirecionamento de paginas de treinamento:</Title>
            <div>
              <Form>
                <Form.Group widths="equal">
                  <Form.Field
                    control={Input}
                    label="URL a ser Redirecionada:"
                    placeholder="De"
                    onChange={(e) => {
                      setNewRed({ ...newRed, url_saida: e.target.value });
                    }}
                  />
                </Form.Group>

                <Form.Group widths="equal">
                  <Form.Field
                    control={Input}
                    label="Redirecionamento Concluido:"
                    placeholder="Para"
                    onChange={(e) => {
                      setNewRed({ ...newRed, url_destion: e.target.value });
                    }}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Field control={Button} onClick={() => create()}>
                    Criar
                  </Form.Field>
                </Form.Group>
              </Form>
            </div>
            <div>
              <SemanticTable size="big" celled>
                <SemanticTable.Header>
                  <SemanticTable.Row>
                    <SemanticTable.HeaderCell>ID</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>De</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>Para</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
                  </SemanticTable.Row>
                </SemanticTable.Header>
                {redirect.length > 0 ? (
                  <SemanticTable.Body>
                    {redirect.map((red, index) => (
                      <SemanticTable.Row>
                        <SemanticTable.Cell>{red.id}</SemanticTable.Cell>
                        <SemanticTable.Cell>{red.url_saida}</SemanticTable.Cell>
                        <SemanticTable.Cell>
                          {red.url_destion}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>
                          <>
                            <Button
                              icon="trash icon"
                              color={"red "}
                              onClick={() => removeRedirect(red.id)}
                            />
                          </>
                        </SemanticTable.Cell>
                      </SemanticTable.Row>
                    ))}
                  </SemanticTable.Body>
                ) : (
                  <h3>Nenhum Redirecionamento encontrado</h3>
                )}
              </SemanticTable>
            </div>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(Redirecionamento);
